const points = [
  { icon: 'ri-check-double-line', text: 'какие компетенции у сотрудников уже развиты' },
  { icon: 'ri-alert-line', text: 'каких компетенций не хватает' },
  { icon: 'ri-arrow-up-circle-line', text: 'кто готов к более сложной роли' },
  { icon: 'ri-book-open-line', text: 'кому требуется обучение' },
  { icon: 'ri-vip-crown-line', text: 'кого можно включить в кадровый резерв' },
  { icon: 'ri-rocket-line', text: 'какие сотрудники обладают высоким потенциалом' },
  { icon: 'ri-error-warning-line', text: 'где существуют риски для бизнеса' },
  { icon: 'ri-focus-3-line', text: 'какие компетенции развивать в первую очередь' },
];

const chain = ['Оценка', 'Решение', 'Развитие', 'Повторная оценка'];

export default function WhatIsAssessment() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Зачем компании оценивать сотрудников
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Оценка сотрудников нужна не ради самой оценки и не для того, чтобы составить очередной рейтинг работников. Её задача — понять конкретные вещи:
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-14">
          {points.map((p, i) => (
            <div key={i} className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl border border-gray-100 hover:border-teal-200 transition-colors">
              <div className="w-9 h-9 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className={`${p.icon} text-teal-700`}></i>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{p.text}</p>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-2xl border border-teal-100 p-6 md:p-10">
          <p className="text-sm md:text-base text-gray-700 text-center mb-6 leading-relaxed">
            Оценка — это не конечная точка, а часть цикла развития сотрудника:
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            {chain.map((step, i) => (
              <div key={i} className="flex items-center gap-3">
                <div className="bg-teal-600 text-white px-5 py-3 rounded-lg font-semibold text-sm md:text-base whitespace-nowrap">
                  {step}
                </div>
                {i < chain.length - 1 && (
                  <i className="ri-arrow-right-line text-teal-500 text-xl"></i>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}